"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLivingEnemies = void 0;
const getLivingEnemies = (piece, board, pieceRegistry, combatStore) => board
    .getAllPieces()
    .map((p) => pieceRegistry.getPieceById(p.id))
    .filter((other) => other !== null &&
    other.ownerId !== piece.ownerId &&
    combatStore.getPiece(other.id).currentHealth > 0);
exports.getLivingEnemies = getLivingEnemies;
